'use client'

/**
 * PDP FEATURE_SHOWCASE PL widget. Thin router: renders the Panda `FeatureGridDS` block when the Design
 * System gate is active, else the legacy `FeatureSectionTwo` branch. The legacy branch keeps serving
 * 100% of traffic until the DS rollout ramps.
 */

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { FeatureShowcaseDSWidget } from './feature-showcase-ds-widget'
import { FeatureShowcaseWidgetLegacy } from './feature-showcase-widget-legacy'

import type { FeatureShowcaseWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

function FeatureShowcaseWidgetComponent(props: PLTypedWidgetProps<FeatureShowcaseWidgetData>) {
  if (shouldUseDesignSystem()) {
    return <FeatureShowcaseDSWidget {...props} />
  }
  return <FeatureShowcaseWidgetLegacy {...props} />
}

export const FeatureShowcaseWidget: PLTypedWidgetInterface<FeatureShowcaseWidgetData, WidgetType.FEATURE_SHOWCASE> = {
  id: WidgetType.FEATURE_SHOWCASE,
  errorBoundary: PLBaseErrorBoundary,
  render: FeatureShowcaseWidgetComponent,
}
